import { highlightParts } from '@/lib/queries';

type HighlightTextProps = {
  text: string;
  keyword: string;
  className?: string;
};

export default function HighlightText({ text, keyword, className = '' }: HighlightTextProps) {
  const parts = highlightParts(text, keyword);

  return (
    <span className={className}>
      {parts.map((part, index) =>
        part.hit ? (
          <mark key={index} className="rounded bg-accent-500/25 px-0.5 text-accent-300">
            {part.text}
          </mark>
        ) : (
          <span key={index}>{part.text}</span>
        ),
      )}
    </span>
  );
}